import { useAuth } from 'react-oidc-context';
import Divider from '../Divider';
import Link from '../Link';
import Button from '../Buttons/Button';
import Checkbox from '../Form/Checkbox';
import { FilterButtonGroupProps } from '../FindAProgram/types';
import { isWebEditors } from '@/utils/roleHelpers';

type SearchFooterProps = {
  filterGroups?: FilterButtonGroupProps[];
  onClearAll?: () => void;
  onSearch?: () => void;
  showExplanation?: boolean;
  onShowExplanationChange?: (checked: boolean) => void;
  disableDecayFunctions?: boolean;
  onDisableDecayFunctionsChange?: (checked: boolean) => void;
};

const SearchFooter: React.FC<SearchFooterProps> = ({ 
  filterGroups, 
  onClearAll, 
  onSearch,
  showExplanation = false,
  onShowExplanationChange,
  disableDecayFunctions = false,
  onDisableDecayFunctionsChange
}) => {
  const auth = useAuth();
  
  // Wait for auth to be ready before checking roles
  const isAuthReady = !auth.isLoading && auth.isAuthenticated !== undefined;
  const isWebEditorsRole = isAuthReady && isWebEditors(auth);

  const handleExplanationChange = (checked: boolean) => {
    onShowExplanationChange?.(checked);
  };

  const handleDisableDecayFunctionsChange = (checked: boolean) => {
    onDisableDecayFunctionsChange?.(checked);
  };

  return (
    <>
      <Divider color="light" />
      <div className="flex h-full items-center justify-between gap-4" data-component="SearchFooter">
        {filterGroups?.some(item => item.filters.some(item => item.checked)) && (
          <Link variant="text-link-2" text="Clear all" onClick={onClearAll} as="button" />
        )}
        
        {/* WebEditors Role Only: Display Checkboxes */}
        {/* Only show after auth is ready to avoid flicker */}
        {isAuthReady && isWebEditorsRole && (
          <div className="ml-auto flex items-center gap-4">
            <Checkbox
              id="display-explanation-checkbox"
              name="displayExplanation"
              checked={showExplanation}
              onCheckedChange={handleExplanationChange}
              asFormField={false}
              className="shrink-0"
            >
              <Checkbox.Label className="whitespace-nowrap">
                Explain Mode
              </Checkbox.Label>
            </Checkbox>
            
            <Checkbox
              id="disable-decay-functions-checkbox"
              name="disableDecayFunctions"
              checked={disableDecayFunctions}
              onCheckedChange={handleDisableDecayFunctionsChange}
              asFormField={false}
              className="shrink-0"
            >
              <Checkbox.Label className="whitespace-nowrap">
                Disable Decay Functions
              </Checkbox.Label>
            </Checkbox>
          </div>
        )}
        
        <Button 
          color="red" 
          label="Search" 
          size="large" 
          className={!isWebEditorsRole || !filterGroups?.some(item => item.filters.some(item => item.checked)) ? 'ml-auto' : ''} 
          onClick={onSearch} 
        />
      </div>
    </>
  );
};

export default SearchFooter;
